import { axiosInstance } from "./apiInstance";
import * as urls from "./urls.json";

/**
 * Fetches the address details based on the provided pincode.
 *
 * @param params - The parameters for the API request.
 * @param params.pincode - The pincode to look up the address for.
 *
 * @returns  A promise that resolves with the API response data.
 */
export const fetchAddressByPincode = (params: { pincode: string }) =>
	axiosInstance.get(urls.getAddressByPincode, {
		params,
	});

/**
 * Create Warehouse
 *
 * Creates a new warehouse.
 *
 * @param data - The warehouse data
 * @returns Axios promise with the response
 */
export const createWarehouse = (data: unknown) =>
	axiosInstance.post(urls.createWarehouse, data);

/**
 * Search Warehouses
 *
 * Searches for warehouses based on filters and query.
 *
 * @param pageNo - Page number
 * @param filterVals - Filter values
 * @param query - Search query
 * @param fetchAll - Whether to fetch all records
 * @param signal - Optional AbortSignal for request cancellation
 * @returns Axios promise with the response
 */
export const searchWarehouses = (
	pageNo?: number,
	filterVals?: Record<string, unknown>,
	query?: string,
	fetchAll?: boolean,
	signal?: AbortSignal
) => {
	const config: {
		params: Record<string, unknown>;
		signal?: AbortSignal;
	} = {
		params: {
			all_records: fetchAll || undefined,
			q: query || undefined,
			client__id: 6488,
			...(filterVals || {}),
		},
	};
	if (signal) {
		config.signal = signal;
	}
	return axiosInstance.get(urls.getWarehouseList, config);
};

/**
 * Get Top Used Warehouses
 *
 * Fetches the most used warehouses.
 *
 * @param pageNo - Page number
 * @param filterVals - Filter values
 * @param signal - Optional AbortSignal for request cancellation
 * @returns Axios promise with the response
 */
export const getTopUsedWarehouses = (
	pageNo?: number,
	filterVals?: Record<string, unknown>,
	signal?: AbortSignal
) => {
	const config: {
		params: Record<string, unknown>;
		signal?: AbortSignal;
	} = {
		params: {
			page: pageNo || 1,
			client__id: 6488,
			type_of_warehouse: "source",
			...(filterVals || {}),
		},
	};
	if (signal) {
		config.signal = signal;
	}
	return axiosInstance.get(urls.getTopWarehouseList, config);
};
